import { Component, OnInit, ViewChild } from "@angular/core";
import { DeviceSearchResult } from "../DeviceSearchResult/DeviceSearchResult";
import { Device_SearchRequest } from "../../Models/RequestModels";
import { DeviceService } from "../../Services/DeviceService";
import { AppSettings } from "../../Library/AppSettings";


@Component({
    selector: "DeviceConsole",
    templateUrl: "./DeviceConsole.html"
})
export class DeviceConsole implements OnInit {
    @ViewChild("deviceSearchResult") deviceSearchResult: DeviceSearchResult;
    RequestModel: Device_SearchRequest;
    Status_List: any[] = [];
    AppSettings = AppSettings;

    constructor(public deviceService: DeviceService) {}

    ngOnInit() {
        this.InitRequestModel();
    }

    InitRequestModel() {
        this.RequestModel = new Device_SearchRequest();
        this.RequestModel.DeviceStatus = 0;
        this.SetData();
        this.Status_List = [
            {
                Id: 0,
                Name: "ENTITIES.ENTITIES_ALL"
            },
            {
                Id: 1,
                Name: "LBL.ACTIVE"
            },
            {
                Id: 2,
                Name: "LBL.INACTIVE"
            }
        ];
    }

    SetData(): void {
        this.deviceSearchResult.RequestModel = this.RequestModel;
        this.deviceSearchResult.Show();
    }

    OnFilter(item): void {
        this.RequestModel.DeviceStatus = item.Id;
        this.deviceSearchResult.RequestModel.DeviceStatus = item.Id;
        this.deviceSearchResult.FilterData();
    }

    RefreshData(){
        // this.RequestModel.DeviceStatus = 0;
        this.deviceSearchResult.RefreshData();
    }

    DeactivateAllDevices(){
        this.deviceSearchResult.DeactivateAllDevices();
    }

}
